import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';

import { Router } from '@angular/router';
import { ThemeService } from '../../shared/services/theme.service';
import { map, catchError, of, Observable } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { AuthService } from 'acl-cloud-lib';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { Breadcrumb, BreadcrumbService } from '../../shared/services/breadcrumb.service';
import { environment } from 'src/environments/environment';
import { DashboardDataService } from '../../pages/dashboard-page/data/dashboard-data.service';
@Component({
  selector: 'app-header',
  templateUrl: 'header.component.html',
  styleUrls: ['./header.component.scss']
})

export class HeaderComponent implements OnInit {
  modalRef?: BsModalRef;
  breadcrumbs$: Observable<Breadcrumb[]>;

  @Output()
  menuToggle = new EventEmitter<boolean>();

  @Input()
  menuToggleEnabled = false;

  @Input()
  title!: string;

  constructor(
    private theme: ThemeService,
    private router: Router,
    private authService: AuthService,
    private readonly breadcrumbService: BreadcrumbService,
    private readonly dashboardService: DashboardDataService
  ) {
    this.breadcrumbs$ = breadcrumbService.breadcrumbs$;
  }

  ngOnInit() {
  }

  toggleMenu = () => {
    this.menuToggle.emit();
    this.dashboardService.updatedashboard();
  }

  navigateToHome() {
    this.router.navigate(['/home']);
  }
}

